(function(){
	var map, mapMarkers;
	var WP_theme = agencesAjax.WP_theme;
	var dossierDist = WP_theme + "/dist"; //Répertoire des images


	var doMarker = function (markerData) {
		if ( markerData.lat !== '' && markerData.lng !== '' ) {

			var marker = L.marker([markerData.lat, markerData.lng], {
				icon: L.icon({
					iconUrl: dossierDist + '/images/bulleK.d02262b2.png',
					iconSize: [32, 44],
					iconAnchor: [16, 44], // ancre sur top-center left par défaut
					tooltipAnchor: [15, 0],
					popupAnchor: [0, -44]
				}),
				zIndex: 999
			});

			var request = new XMLHttpRequest();
			request.open('POST', agencesAjax.ajaxurl + "?action=agence_popup&security=" + agencesAjax.security + "&id=" + markerData.id, true);
			request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

			request.onload = function() {
				if (200 === this.status) {
					var json = JSON.parse(this.response);

					marker.bindPopup(json.html);
				} else {
					console.log('fail | status : ' + this.status + ' | response : ' + this.response);
				}
			};

			request.onerror = function() {
				console.log('connection error');
			};

			request.send();

			mapMarkers.addLayer(marker);
		}
	}

	//~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~
	// Init de la Carte
	var initializeMap = function () {
		var mapNode = document.querySelector("#maps");
		var markersDatas = JSON.parse(mapNode.getAttribute("data-maps"));
		var latLng = [];

		markersDatas.forEach(function(markerData){
			if ( markerData.lat !== '' && markerData.lng !== '' ) {
				latLng.push([markerData.lat, markerData.lng]);
			}
		});

		var bounds = L.latLngBounds(latLng).pad(0.1); // TODO régler le padding
		L.Map.addInitHook("addHandler", "gestureHandling", leafletGestureHandling.GestureHandling);
		// L.Map.addInitHook("addHandler", "markercluster", Leaflet.markercluster);

		var mapOptions = {
			center: bounds.getCenter(),
			debounceMoveend: true,
			gestureHandling: true,
			gestureHandlingOptions: {
				duration: 1500
			}
		};
		map = L.map("maps", mapOptions);
		map.fitBounds(bounds);

		var osm = new L.TileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
		});
		map.addLayer(osm);

		// mapMarkers = new L.LayerGroup().addTo(map);
		mapMarkers = L.markerClusterGroup({
			chunkedLoading: true,
			iconCreateFunction: function() {
				return L.icon({
					iconUrl: dossierDist + '/images/bulleK.d02262b2.png',
					iconSize: [32, 44],
					iconAnchor: [16, 44], // ancre sur top-center left par défaut
					tooltipAnchor: [15, 0],
					popupAnchor: [0, -44]
				});
			}
		});

		// mapMarkers.clearLayers();

		markersDatas.forEach(doMarker);
		map.addLayer(mapMarkers);
	}

	initializeMap();
})();
